import styled from "styled-components";

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 0 130px;
  > img {
    max-width: 100%;
  }

  @media (max-width: 991px) and (min-width: 576px) {
    margin: 0 0 60px;
  }

  @media (max-width: 575px) {
    margin: 0 0 30px;
  }
`;

export const Info = styled.div`
  background-color: ${props => props.theme.colors[0]};
  padding: 40px 28px;
  text-align: center;
  height: 100%;

  > h2 {
    font-family: Oswald;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.01em;
    color: ${props => props.theme.colors[37]};
    margin: 0;
  }

  > h3 {
    text-align: left;
    font-family: Oswald;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: ${props => props.theme.colors[37]};
    margin: 0;
  }

  > a {
    font-family: Oswald;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.01em;
    color: ${props => props.theme.colors[19]};
  }

  @media (min-width: 1200px) {
    min-height: 600px;
  }

  @media (max-width: 1199px) and (min-width: 992px) {
    min-height: 500px;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    min-height: 400px;
  }

  @media (max-width: 575px) {
    padding: 20px;

    > h2 {
      font-size: 20px;
      line-height: 30px;
    }

    > a {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;
